import {useSyncExternalStore} from "react";
import {
	NO_PURCHASE_USE_INTENT,
	type PurchaseUseIntent,
	purchaseUseIntentState,
	subscribePurchaseUseIntent,
} from "./purchaseUseIntent";

/**
 * Which purchase "Use it" was pressed for, as this mount reads it (kitecorp/transferify-ui#3004).
 *
 * A thin React adapter over the React-free `./purchaseUseIntent` store, which holds the state because the
 * press and the strip that answers it live in different subtrees. The server snapshot is "nobody": the
 * create panel is pre-rendered on the public landing, and the pre-rendered HTML and the first client
 * render must agree (ui#74/#418).
 */
export function usePurchaseUseIntent(): PurchaseUseIntent {
	return useSyncExternalStore(
		subscribePurchaseUseIntent,
		purchaseUseIntentState,
		() => NO_PURCHASE_USE_INTENT,
	);
}
